import { motion } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { CreditCard, CloudOff, Package } from 'lucide-react';

const icons = [CreditCard, CloudOff, Package];

export const ProblemSection = () => {
  const { t } = useI18n();
  const points = t('problem.points');

  return (
    <section className="relative py-16 sm:py-24 md:py-32 bg-background" data-testid="problem-section">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] sm:w-[500px] h-[200px] sm:h-[300px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-500/5 via-transparent to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-10 sm:mb-16">
          <span className="text-xs uppercase tracking-[0.2em] text-red-500/70 font-medium" data-testid="problem-tag">{t('problem.tag')}</span>
          <h2 className="font-heading text-2xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground mt-3" data-testid="problem-title">{t('problem.title')}</h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {Array.isArray(points) && points.map((p, i) => {
            const Icon = icons[i];
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="p-8 rounded-2xl bg-red-500/5 border border-red-500/10 hover:border-red-500/20 transition-colors"
                data-testid={`problem-card-${i}`}>
                <div className="w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-red-500" />
                </div>
                <h3 className="text-foreground font-medium text-lg mb-2">{p.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
